import auth from '@/plugins/auth'
import { getAgentInfo as getInfo } from '@/api/limit';
import router, { constantRoutes, dynamicRoutes } from '@/router'
import Layout from '@/views/index'
 
 const user = {
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    user: {},
    menuIds: [],
    roles:[],
    permissions: [],
    showRobot: false,
    showPrefill: false,
    routeSearch: {},
  },
  mutations: {
    SET_USERINFO: (state, params) => {
      state.userInfo = params
    },
    SET_MENUIDS: (state, params) => {
      state.menuIds = params
    },
    SET_USER: (state, params) => {
      state.user = params
    },
    SET_ROLES: (state, params) => {
      state.roles = params
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_SHOW_ROBOT: (state, params) => {
      state.showRobot = params
    },
    SET_SHOW_PREFILL: (state, params) => {
      state.showPrefill = params
    },
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_DEFAULT_ROUTES: (state, routes) => {
      state.defaultRoutes = constantRoutes.concat(routes)
    },
    SET_TOPBAR_ROUTES: (state, routes) => {
      state.topbarRouters = routes
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },
    SET_ROUTE_SEARCH: (state, params) => {
      state.routeSearch[params.name] = params.searchOpt
    },
  },
  actions: {
    setUserInfo({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_USERINFO', data)
        resolve()
      })
    },
    setMenuIds({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_MENUIDS', data)
        resolve()
      })
    },
    setUser({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_USER', data)
        resolve()
      })
    },
    setRoles({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_ROLES', data)
        resolve()
      })
    },
    setPermissions({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_PERMISSIONS', data)
        resolve()
      })
    },
    setShowRobot({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_SHOW_ROBOT', data)
        resolve()
      })
    },
    setShowPrefill({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_SHOW_PREFILL', data)
        resolve()
      })
    },
    setRouteSearch({ commit }, data) {
      return new Promise(resolve => {
        const { name, searchOpt } = data
        const currentRoute = router.currentRoute
        commit('SET_ROUTE_SEARCH', data)

        let newQuery = { ...currentRoute.query }
        if (searchOpt === null || searchOpt === undefined) {
          // 如果是重置，清除该页面相关的搜索参数（可选：清除所有以 page- 开头的）
          Object.keys(newQuery).forEach(key => {
            if (key.startsWith(`${name}-`)) {
              delete newQuery[key]
            }
          })
        } else {
          // 把 searchOpt 的每个字段加前缀（避免冲突），写入 query
          Object.keys(searchOpt).forEach(key => {
            const queryKey = `${name}-${key}` // 防止不同页面字段名冲突
            const value = searchOpt[key]
            
            if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)) {
              delete newQuery[queryKey]
            } else if (typeof value === 'object' && !Array.isArray(value)) {
              // 对象类型序列化为JSON字符串
              newQuery[queryKey] = JSON.stringify(value)
            } else {
              // 转成字符串（数组会变成 "a,b"）
              newQuery[queryKey] = Array.isArray(value) ? value.join(',') : value
            }
          })
        }
        
        // 只有当 query 发生变化时才替换，避免重复触发
        if (JSON.stringify(currentRoute.query) !== JSON.stringify(newQuery)) {
          router.replace({
            query: newQuery
          }).catch(err => {
            // 忽略 NavigationDuplicated 错误
            if (err.name !== 'NavigationDuplicated' && !err.message.includes('Aborted')) {
              console.error(err)
            }
          })
        }

        resolve()
      })
    },
    // 获取用户信息
    GetInfo({ commit, state, rootGetters, dispatch }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          if (!res || typeof res !== 'object') return;
          // 修复用户token过期时的处理。
          if ([401].includes(res?.code) || !res?.data) {
              localStorage.removeItem("newToken")
              return
          }
          const { permissions = [], routers = [] } = res?.data
          if (!permissions) {
            reject(new Error('getInfo: permissions is not null'))
          }
          if (!routers) {
            reject(new Error('getInfo: routers is not null'))
          }
          if (Array.isArray(permissions) && permissions.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_PERMISSIONS', permissions)
          } else {
            commit('SET_PERMISSIONS', ['noPermissions']) // 如果存在permissions，但permissions是空数组，则给persmissions赋值一个无意义数组
            // reject(new Error('permissions is not Array'))
            // 如果用户无角色，修改路由配置中的标题为导航页。
            const routes = router.options.routes
            const homeRoute = routes.find(route => route.path === '/home')
            if (homeRoute) {
              homeRoute.meta.title = 'sidebar.default'
            }
            if (rootGetters?.sidebar?.opened) {
              dispatch('settings/toggleSideBar') 
            }
          }
          const sdata = JSON.parse(JSON.stringify(routers))
          const rdata = JSON.parse(JSON.stringify(routers))
          const sidebarRoutes = filterAsyncRouter(sdata)
          const rewriteRoutes = filterAsyncRouter(rdata, false, true)
          const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
          rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          // router.addRoutes(asyncRoutes);
          // “router.addRoutes”的签名“(routes: RouteConfig[]): void”已弃用
          asyncRoutes.forEach(route => {
            router.addRoute(route);
          });
          commit('SET_ROUTES', rewriteRoutes)
          commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
          commit('SET_DEFAULT_ROUTES', sidebarRoutes)
          commit('SET_TOPBAR_ROUTES', sidebarRoutes)
          resolve(rewriteRoutes)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      // } else if (route.component === 'ParentView') {
      //   route.component = ParentView
      // } else if (route.component === 'InnerLink') {
      //   route.component = InnerLink
      } else {
        // console.log('route.component', route.component)
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView' && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    }
  })
  return res
}

export const loadView = (view) => {
  // if (process.env.NODE_ENV === 'development') {
  //   return (resolve) => require([`@/views/${view}`], resolve)
  // } else {
  //   // 使用 import 实现生产环境的路由懒加载
  //   return () => import(`@/views/${view}`)
  // }
  return () => import(`@/views/${view}`)
}

export default user
